module.exports = __webpack_public_path__ + "img/link.658fa3d7.svg";